const expColumns = t => {
  return [
    {
      title: '№',
      value: 'id',
      key: 'history1',
      dataIndex: 'id',
      width: 30,
    },
    {
      title: t('insurance_contracts.number_info'),
      value: 'details',
      key: 'history2',
      dataIndex: 'details',
      width: 150,
      render: number => number,
    },
    {
      title: t('insurance_contracts.success_info'),
      value: 'success',
      key: 'history3',
      dataIndex: 'success',
      width: 100,
      render: status => (status ? t('insurance_contracts.exported_info') : t('insurance_contracts.not_exported_info')),
    },
    {
      title: t('insurance_contracts.message_info'),
      value: 'message',
      key: 'history4',
      dataIndex: 'message',
      width: 110,
    },
  ];
};

export default expColumns;
